package com.sddamico.swigmore.ds.feedback

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwEffects
import com.sddamico.swigmore.ds.core.Card
import com.sddamico.swigmore.ds.core.CardVariant
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeBody
import com.sddamico.swigmore.ds.typeDisplay
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/** Gold confirmation band with trailing actions ("Your ballot is in." · AMEND · WITHDRAW). */
@Composable
fun Banner(
  title: String,
  modifier: Modifier = Modifier,
  body: String? = null,
  actions: (@Composable () -> Unit)? = null,
) {
  Card(
    Modifier.css("display" to "flex", "flex-wrap" to "wrap", "gap" to "12px", "align-items" to "center",
      "justify-content" to "space-between").then(modifier),
    variant = CardVariant.Gold, padding = "14px 16px", radius = SwEffects.radiusCard,
  ) {
    Div {
      Div(attrs = Modifier.typeDisplay("18px", "normal").toAttrs()) { Text(title) }
      if (body != null) Div(attrs = Modifier.typeBody("13px", 500, "1.4").css("margin-top" to "3px").toAttrs()) { Text(body) }
    }
    if (actions != null) Div(attrs = Modifier.css("display" to "flex", "gap" to "8px").toAttrs()) { actions() }
  }
}
